import React , { useEffect }from 'react';
import { Modal, Form, Input, Button, message} from 'antd';
import { ChangeLicense } from '../api/ChangeEmail';
import { BrokerData } from '../constant';

interface ChangeEmailModalProps {
    visible: boolean;
    licenseNumber: string;
    onCancel: () => void;
    onSetlicenseNumber: (broker: BrokerData | null) => void;
  }
  
const ChangeLicenseModal: React.FC<ChangeEmailModalProps> = ({ visible, licenseNumber, onCancel, onSetlicenseNumber }) => {
  const [form] = Form.useForm();

    useEffect(() => {
      form.setFieldsValue({ licenseNumber: licenseNumber });
    }, [licenseNumber, form]);

  const onFinish = (newLicense: any) => {

    ChangeLicense(newLicense)
        .then((resetresponse) => {
          if (resetresponse.success)
          {
            onSetlicenseNumber(resetresponse.broker)
            message.success("Successfully changed license number")
          }
          else{
            message.error(resetresponse.msg)
          }
        })
        .catch((error) => {
          console.error("An error occurred:", error.message);
          return
        });   
    
    form.resetFields();  
    onCancel();  
  };

  return (
    <Modal
      open={visible}
      title="Change License Number"
      className='register-text-style'
      onCancel={onCancel}
      footer={null}
      width={300}
      centered={true}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ marginTop: 20 }}
      >

        {/* Email Address and License Number */}
        <Form.Item
          label="License Number : "
          name="licenseNumber"
          rules={[
            { required: true, message: 'Please input the license number!' },
          ]}
        >
            <Input className='register-input-style'/>
        </Form.Item>
        <div  className='justify-items-center'>
            <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '200px'}}>
                Change
            </Button>
            </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};


export default ChangeLicenseModal;